import React from 'react'
import { Doughnut } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js'

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend)

const OrderPieChart = ({ data }) => {

  const chartData = {
    labels: [
      "Incoming Harvest",
      "Outgoing Harvest",
      "Prospective harvest weight loss",
    ],
    datasets: [
      {
        data: [
          data?.incoming_harvest,
          data?.outgoing_harvest,
          data?.prospective_harvest_weight_loss,
        ],
        backgroundColor: [
          '#4C78FF',  // Blue for completed
          '#FF82AC',  // Pink for pending
          '#16DBCC',  // Green for cancelled
        ],
        borderColor: '#fff',
        borderWidth: 2,
        cutout: '50%',
      },
    ],
  }

  const options = {
    responsive: true,
    plugins: {
      legend: {
        // position: 'bottom',
        display: false,
        // labels: {
        //   padding: 20,
        //   usePointStyle: true,
        //   pointStyle: 'circle',
        // },
      },
    },
    // cutout: '55%',
    elements: {
      arc: {
        borderWidth: 0,
        shadowColor: 'rgba(0, 0, 0, 0.2)',
        shadowBlur: 20,
        shadowOffsetX: 0,
        shadowOffsetY: 5,
      },
    },
  }
  return (
    <div className="-m-1.5 overflow-x-auto">
      <div className="p-1.5 min-w-full inline-block align-middle">
        <div className="bg-white dark:bg-dark border dark:border-border-dark dark:text-white bg-clip-border rounded-lg shadow-sm overflow-hidden ">
          <div className="bg-white dark:bg-dark border-b border-gray-200 dark:border-border-dark p-4 flex flex-row items-center justify-between">
            <h1 className='text-lg font-bold'>
              Orders
            </h1>
            <select
              name="filter"
              id="filter"
              className="py-2 capitalize border-none px-5 pe-9 bg-gray-100 dark:bg-secondaryDark rounded-lg text-sm disabled:opacity-50 focus:border-white focus:ring-white  disabled:pointer-events-none"
            >
              <option value="month">This month</option>
            </select>
          </div>
          <div className='p-4 bg-white dark:bg-dark'>
            <div className="w-full max-w-[230px] mx-auto">
              <Doughnut data={chartData} options={options} />
            </div>

            <div className="space-y-2 w-full mt-5">
              {chartData?.datasets[0]?.data?.map((item, index) => (
                <div key={index} className="flex flex-row items-center justify-between w-full">
                  <div className="flex flex-row items-center justify-between w-full">
                    <div className='flex flex-row items-center gap-3'>
                      <div className={`w-3 h-3 rounded-full`}
                        style={{
                          backgroundColor: chartData?.datasets[0]?.backgroundColor[index],
                        }}
                      />
                      <h3 className="text-sm text-black dark:text-white capitalize">
                        {chartData?.labels[index]}
                      </h3>
                    </div>

                    <h3 className="text-base capitalize">
                      {item}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OrderPieChart